import React from "react";
import classNames from "classnames";
import { Navigate, Route, Routes } from "react-router";
import { TabProps } from ".";

interface ContentProps {
  tabs: Array<TabProps>;
  path: string;
  className: string;
}

const Content: React.FC<ContentProps> = ({ tabs, path, className }: ContentProps): JSX.Element => {
  let redirect = null;

  // redirect from root path to the first tab
  if (tabs.length > 0) {
    redirect = (
      <Route path={path} element={<Navigate to={`${path}${tabs[0].route}`} />} />
    );
  }

  return (
    <div className={classNames("caprx-nav-tabs-content", className)}>
      <Routes>
        {redirect}
        {tabs.map(({ route, component: Component }) => {
          return <Route key={route} path={`${path}${route}`} element={<Component />} />;
        })}
      </Routes>
    </div>
  );
};

export default Content;
